module.exports = __webpack_public_path__ + "img/pc_p2_dibiao.512af1dc.png";